// Display formatting for menu/food items: the leaf emoji for vegetarian items
// and the hot/cold entree label. Shared by the menu selection steps (step-menu,
// step-menu2) and the food/menu choice summaries (food-summary, menu-summary)
// so the rules aren't duplicated across templates.
// Deliberately not applied to drinks or options — they have no vegetarian/entree
// semantics, even though their selection cards share the card-item component.

const VEGETARIAN_EMOJI = '🌿';
const HOT_ENTREE_PREFIX = 'Entrée chaude: ';
const COLD_ENTREE_PREFIX = 'Entrée froide: ';

/** Subset of the legacy menu/food item shape needed for display formatting. */
export interface FormattableMenuItem {
  Titre?: string;
  Description?: string;
  Type?: string;
  Preparation?: string;
  Vegetarien?: string;
}

/** Item title, prefixed with a leaf emoji when the item is vegetarian. */
export function formatMenuItemTitle(item?: FormattableMenuItem | null): string {
  const title = item?.Titre ?? '';
  if (!title) return '';
  return item?.Vegetarien === 'oui' ? `${VEGETARIAN_EMOJI} ${title}` : title;
}

/**
 * Item description. Entrees are labelled with their serving temperature
 * ("Entrée chaude: " for a 'chaud' preparation, "Entrée froide: " for 'froid').
 * Any other type — or an entree whose preparation is missing/unrecognised — is
 * returned unchanged, so we never assert a temperature we can't substantiate.
 * An empty description yields an empty string (no bare, content-less label).
 */
export function formatMenuItemDescription(item?: FormattableMenuItem | null): string {
  const description = item?.Description ?? '';
  if (!description) return '';
  if (item?.Type === 'entree') {
    if (item.Preparation === 'chaud') return `${HOT_ENTREE_PREFIX}${description}`;
    if (item.Preparation === 'froid') return `${COLD_ENTREE_PREFIX}${description}`;
  }
  return description;
}
